import noop from 'lodash/noop';
import { Moment } from 'moment';
import { moment } from '../lib/moment';
// import { TimePickerConfig } from 'ng-zorro-antd/core/config';
import { TimePickerConfig } from 'ng-zorro-antd/core';

import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { getTimeInUserTimeZone } from '../lib/utils';
import { DEFAULT_TIME_ZONE } from '../lib/time-zones';

const DATE_TIME_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line:no-use-before-declare
  useExisting: forwardRef(() => DateTimePickerComponent),
  multi: true,
};

@Component({
  providers: [DATE_TIME_PICKER_VALUE_ACCESSOR],
  selector: 'date-time-picker',
  templateUrl: './date-time-picker.component.html',
})
export class DateTimePickerComponent implements ControlValueAccessor {
  @Input() public placeholder: string = 'Select date/time';
  @Input() public disable: boolean = false;
  @Input() public dateTimeFormat: string = 'DD-MM-YY hh:mm a';
  @Input() public shouldShowTimePicker: boolean = true;
  @Input() public shouldUse12HoursFormat: boolean = true;
  @Input() public timezone: string = DEFAULT_TIME_ZONE;
  @Input() public shouldShowPrefixCalendarIcon: boolean = true;
  @Input() public shouldShowDefaultSuffixCalendarIcon: boolean = false;
  @Input() public shouldShowNowButton: boolean = false;
  @Input() public dropdownClassName: string = '';
  @Output() public onSelect: EventEmitter<Date> = new EventEmitter();
  public isDatetimePickerOpened: boolean = false;
  public currentValue: Date;
  private onTouched: (_: Date) => void = noop;
  private onChange: (_: Date) => void = noop;

  public get value(): Date { return this.currentValue; }

  public set value(v) {
    if (v !== this.currentValue) {
      this.currentValue = v;
      this.onChange(v);
    }
  }

  public get timePickerConfig(): boolean | TimePickerConfig {
    if (!this.shouldShowTimePicker) return false;

    const timePickerConfig: TimePickerConfig = {};
    if (this.shouldUse12HoursFormat) timePickerConfig.nzUse12Hours = 'true';
    timePickerConfig.nzFormat = this.dateTimeFormat;
    return timePickerConfig;
  }

  public registerOnChange(fn: (value: Date) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: Moment | Date): void {
    this.currentValue = moment.isMoment(value) ? getTimeInUserTimeZone(value, this.timezone) : value as Date;
  }

  public toggleTimepickerActiveClass(timepickerDropdownStatus: boolean): void {
    this.isDatetimePickerOpened = timepickerDropdownStatus;
  }

  public updateCurrentValue(dateTime: Date): void {
    this.value = dateTime;
    this.currentValue = dateTime;
    this.onSelect.emit(dateTime);
  }

  public onOk(dateTime: Date): void {
    if (!dateTime) this.updateCurrentValue(new Date());
  }
}
